import { PocDrawer } from 'commons/components/components-wrapper';
import { owcTheme } from 'core/theme/theme.config';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

export const SidesheetDrawerStyled = styled(PocDrawer)`
    /* Drop the host box so it never occupies page flow and the 'mode=over' panel sizes to the
       viewport; '&&' beats owc's ':host { display: flex }'. */
    && {
        display: contents;
    }

    /* OWC-OVERRIDE: force the v6 sidesheet width over owc's 'fit-content' wrapper;
       'overflow: visible' lets the panel's left shadow show. owc-drawer exposes no width prop
       in v7.6.0 and sizes the panel wrapper to its content. Revisit on the next @one upgrade. */
    &&& .owc-drawer__panel-wrapper {
        width: 496px;
        max-width: 90vw;
        overflow: visible;
    }

    /* OWC-OVERRIDE: sit the transparent backdrop below the panel (owc ships it at z-index
       1000000, which would swallow clicks); 'pointer-events: none' keeps the list behind
       interactive, v6-style. owc-drawer has no backdrop z-index or pass-through prop in
       v7.6.0. Revisit on the next @one upgrade. */
    &&& .owc-drawer__backdrop {
        z-index: var(--one-z-index-backdrop);
        pointer-events: none;
    }

    &&& [slot='panel'] {
        /* !important beats owc's scoped rules that content-size the panel and set elevation-4. */
        width: 100% !important;
        border-radius: var(--one-border-radius-4);
        box-shadow: var(--one-elevation-box-shadow-2) !important;
        animation: ${fadeIn} 0.3s ease-in-out;
    }

    [slot='panel'] {
        height: 100%;

        owc-component-header,
        owc-component-footer {
            flex-shrink: 0;
        }

        .sidesheet-drawer__content {
            flex: 1;
            padding: var(--one-spacing-padding-2-xs);
            overflow: auto;
        }

        > owc-progress-spinner {
            margin: auto;
        }
    }

    /* Keep the header options + close icon inline (the native suffix slot stacks them). */
    owc-component-header div[slot='suffix'] {
        display: flex;
        align-items: center;
    }

    owc-component-header div[slot='prefix'] {
        display: flex;
        align-items: center;
        column-gap: ${owcTheme['one-spacing-gap-xs']};
    }

    owc-component-footer div[slot='suffix'] {
        display: flex;
        column-gap: ${owcTheme['one-spacing-gap-m']};
    }

    /* OWC-OVERRIDE: v6-parity divider colour — the native v7 separator renders darker. The
       border comes from the native separator prop; only its colour needs overriding, and
       v7.6.0 exposes no separator-colour prop. */
    owc-component-header.owc-component-header--separator {
        border-bottom-color: ${owcTheme['one-color-gray-100']};
    }

    owc-component-footer.owc-component-footer--separator {
        border-top-color: ${owcTheme['one-color-gray-100']};
    }
`;
